import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=112e5408&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e5408",
  null
  
)

export default component.exports